import { paths } from '@organization/router'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'

export const StaffPartnerPage = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const { id } = useParams()

  const items = [
    {
      label: t('agents'),
      key: paths.partners.agents(id),
      children: <Outlet />
    },
    {
      label: t('teams'),
      key: paths.partners.teams(id),
      children: <Outlet />
    },
    {
      label: t('files'),
      key: paths.partners.media(id),
      children: <Outlet />
    }
  ]

  return (
    <Tabs
      defaultActiveKey={location.pathname}
      onTabClick={(value) => navigate(value)}
      items={items}
    />
  )
}
